
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import Testimonials from './TestimonialKeyword';
import Accordion from './Accordion';

function Punetomumbaisedancabservice() {



    const cardData =
    {
        keyword: 'Pune to Mumbai Sedan Cab Service',
        heading: 'Meghana Cab : Pune to Mumbai Sedan Cab Service',
        headingDescription: 'Meghana Cab offers Pune to Mumbai Sedan Cab Service, ideal for solo travelers, couples, or small families seeking a smooth and affordable intercity travel experience. Our Sedan fleet includes clean and well-maintained vehicles like Swift Dzire, Hyundai Xcent, and similar models, offering a perfect balance of comfort, fuel efficiency, and value. Whether you are heading to Mumbai for business, airport transfers, or leisure, our experienced drivers ensure timely pickups, safe journeys, and door-to-door service. Book your Pune to Mumbai Sedan Cab with Meghana Cab and enjoy a reliable ride with transparent pricing and 24/7 support.',


        top: 'Top Places to Visit in Mumbai with Meghana Cab',

      "topPlaces": [ 
 
  {
    "title": "Gateway of India",
    "description": "The Gateway of India stands as Mumbai’s most enduring symbol, built in 1924 to commemorate the visit of King George V and Queen Mary. Overlooking the Arabian Sea, this colossal basalt arch marks the point from which the last British troops left India, making it both a historical and emotional landmark. Located in Apollo Bunder, it serves as a hub for ferry rides to Elephanta Island and provides stunning views at sunrise and sunset. The Indo-Saracenic style architecture and its vibrant surroundings filled with street vendors, photographers, and tourists make it a dynamic cultural hub."
  },
   {
    "title": "Siddhivinayak Temple",
    "description": "One of the richest and most visited temples in Mumbai, Siddhivinayak is dedicated to Lord Ganesha, the remover of obstacles. Originally built in 1801, it features a gold-plated inner sanctum and a unique idol carved from a single black stone, with the trunk curving to the right. The temple draws politicians, Bollywood celebrities, and millions of devotees annually, especially on Tuesdays when the lines stretch for hours. Despite the crowds, the spiritual atmosphere and meticulous organization make it a peaceful yet powerful experience."
  },
  {
    "title": "Marine Drive & Girgaon Chowpatty",
    "description": "Stretching 3.6 kilometers along the Arabian Sea, Marine Drive is Mumbai’s iconic palm-lined promenade shaped like a necklace, earning it the nickname 'Queen’s Necklace.' It’s a favorite spot for joggers, lovers, and tourists who gather to admire the sea view and city skyline, especially at sunset. At the northern end lies Girgaon Chowpatty, a lively beach known for its street food—bhel puri, pav bhaji, gola—and as a venue for the grand Ganesh Visarjan immersions. The entire stretch embodies Mumbai’s coastal spirit and urban pulse."
  },
   {
    "title": "Elephanta Caves",
    "description": "Located 11 km offshore on Elephanta Island, these 5th-to-8th-century rock-cut caves are a UNESCO World Heritage Site showcasing ancient Indian art dedicated primarily to Lord Shiva. The highlight is the massive Trimurti sculpture—depicting the three aspects of Shiva—carved into a single rock face. The island offers not just religious and artistic significance but also scenic views, lush trails, and a tranquil ferry ride from the Gateway of India, making it a full-day cultural and nature getaway from Mumbai's bustle."
  },
  {
    "title": "Chhatrapati Shivaji Maharaj Terminus (CST)",
    "description": "A masterpiece of Victorian Gothic Revival architecture fused with Indian design, CST (formerly Victoria Terminus) is a UNESCO World Heritage Site and one of India’s busiest railway stations. Constructed in 1887, the terminus features turrets, pointed arches, domes, stained-glass windows, and intricate carvings of animals and deities. It stands as a testament to colonial-era craftsmanship while functioning as a modern-day transport lifeline for over 3 million daily commuters. Its majestic façade is especially breathtaking when illuminated at night."
  },
  {
    "title": "Haji Ali Dargah",
    "description": "Built in 1431 in honor of the Sufi saint Haji Ali, this Indo-Islamic marble dargah sits on a tiny islet 500 meters off the coast, connected by a narrow causeway that floods during high tide. It is visited by people of all religions and backgrounds, symbolizing Mumbai’s spiritual inclusiveness. With white domes, intricate mirror work, and prayers echoing against sea winds, it offers both a religious and atmospheric experience. The view of the Mumbai skyline from the dargah adds a contemplative beauty to the site."
  },
  {
    "title": "Chhatrapati Shivaji Maharaj Vastu Sangrahalaya (Prince of Wales Museum)",
    "description": "Housed in a grand Indo-Saracenic building amidst lush gardens, this museum features over 50,000 artifacts from ancient to modern India. Its galleries cover art, archaeology, armory, numismatics, and decorative arts, including standout collections of miniature paintings, Buddhist sculptures, Mughal weaponry, and European antiques. The museum offers guided tours, audio guides, and children's workshops, making it both educational and engaging for visitors of all ages. Its architectural grandeur and curated exhibits make it one of India’s finest museums."
  },
  {
    "title": "Colaba Causeway",
    "description": "A vibrant shopping and cultural district near the Gateway of India, Colaba Causeway offers a sensory overload of colors, sounds, and flavors. Street stalls sell everything from junk jewelry and antiques to clothing and souvenirs, while iconic cafés like Leopold and Café Mondegar cater to tourists and locals alike. It’s the perfect place to experience Mumbai’s cosmopolitan vibe, blending colonial architecture with contemporary fashion, street food, and bustling life from early morning until late night."
  },
  {
    "title": "Juhu Beach",
    "description": "Juhu Beach is one of Mumbai’s most popular coastal stretches, offering a blend of natural beauty, local flavors, and a touch of celebrity culture. Frequented by locals for evening walks, kite flying, and beachside yoga, the beach is also known for its chaat stalls, pony rides, and occasional film shoots. It's common to spot Bollywood stars residing nearby. The beach also hosts cultural festivals and public events, making it more than just a leisure destination—it’s a slice of Mumbai’s identity."
  },
  {
    "title": "Sanjay Gandhi National Park & Kanheri Caves",
    "description": "This 87-square-kilometer green oasis within city limits offers a rare mix of wildlife sanctuary, recreational space, and ancient history. The park houses deer, leopards, monkeys, and over 250 species of birds, along with a toy train, boating lake, and nature trails. The Kanheri Caves within the park—dating from 1st century BCE to 10th century CE—are a group of over 100 Buddhist rock-cut monasteries and prayer halls. The combination of spirituality, wildlife, and open space makes it one of Mumbai’s most unique destinations."
  }
],

     "services": [
    {
      "name": "Sedan Cab Hire Pune to Mumbai",
      "description": "Hire a comfortable and efficient sedan cab from Pune to Mumbai for business or personal travel. Our fleet includes well-maintained sedans with professional chauffeurs, ideal for city-to-city transfers with smooth ride quality and great mileage."
    },
    {
      "name": "AC Sedan Taxi Pune to Mumbai",
      "description": "Travel in cool comfort with our AC sedan taxi service from Pune to Mumbai. Enjoy a fully air-conditioned ride with plush seating and ample legroom, perfect for hot days or long-distance highway drives."
    },
    {
      "name": "One Way Sedan Cab Pune to Mumbai",
      "description": "Book a one-way sedan cab from Pune to Mumbai without paying for the return fare. Ideal for airport transfers, meetings, or travel plans where return is not immediate, this option is both economical and convenient."
    },
    {
      "name": "Round Trip Sedan Taxi Pune to Mumbai",
      "description": "Choose our round-trip sedan taxi service for your Pune–Mumbai–Pune travel. Retain the same driver and car for both legs of the journey with flexible wait times and an overall cost-effective travel package."
    },
    {
      "name": "Online Sedan Booking Pune to Mumbai",
      "description": "Book your sedan cab from Pune to Mumbai online instantly. Our secure platform provides real-time cab availability, instant fare quotes, and booking confirmation with driver details, all from the comfort of your device."
    },
    {
      "name": "Affordable Sedan Cab Pune to Mumbai",
      "description": "Looking for a cost-effective travel solution? Our sedan cabs offer a great balance of comfort and affordability. Choose from top models like Dzire, Xcent, or Amaze at rates that suit your travel budget."
    },
    {
      "name": "Chauffeur Driven Sedan Pune to Mumbai",
      "description": "Enjoy a relaxed ride with our chauffeur-driven sedan cab from Pune to Mumbai. Our experienced drivers ensure on-time pickup, safe driving, and customer-friendly service for a worry-free journey."
    },
    {
      "name": "Private Sedan Travel Pune to Mumbai",
      "description": "Book a private sedan cab for a quiet, uninterrupted ride from Pune to Mumbai. Ideal for solo travelers, couples, or executives, this service offers door-to-door pickup and complete privacy."
    },
    {
      "name": "Comfortable Sedan Pune to Mumbai Ride",
      "description": "Our sedans are designed for comfort during long-distance travel. From cushioned seats to smooth suspension, every detail is tailored to offer a pleasant experience over the expressway."
    },
    {
      "name": "Budget Sedan Hire Pune Mumbai Route",
      "description": "Travel smart with our budget-friendly sedan rentals for the Pune to Mumbai route. Get a clean, reliable vehicle with verified drivers and transparent pricing—perfect for daily commuters or weekend travelers."
    },
    {
      "name": "Sedan Car Rental Pune to Mumbai",
      "description": "Rent a sedan for a day or longer to travel from Pune to Mumbai. Whether it's a personal trip or professional tour, our rental service includes driver, fuel, tolls, and all necessary support for a smooth journey."
    },
    {
      "name": "Long Drive Sedan Pune to Mumbai",
      "description": "Planning a long drive to Mumbai? Our sedans offer comfort, fuel-efficiency, and stability for long-distance road trips. Enjoy the journey with music, air conditioning, and clean interiors."
    },
    {
      "name": "Corporate Sedan Travel Pune to Mumbai",
      "description": "Our corporate sedan cab service is tailored for business travel between Pune and Mumbai. With on-time pickups, GST billing, and courteous drivers, it’s the perfect choice for executives and clients."
    },
    {
      "name": "Fast Sedan Cab Pune to Mumbai",
      "description": "Need to reach Mumbai quickly from Pune? Our fast sedan cab service ensures minimal delays, experienced highway drivers, and efficient travel without compromising on comfort or safety."
    },
    {
      "name": "Family Sedan Cab Pune to Mumbai",
      "description": "Travel with your family in our spacious sedan cabs that offer comfort and safety for all. Ideal for small families, this service includes door-to-door pickup and plenty of boot space for luggage."
    }
  ],
  "tableData": [
    ["Sedan Cab Hire Pune to Mumbai", "AC Sedan Taxi Pune to Mumbai"],
    ["One Way Sedan Cab Pune to Mumbai", "Round Trip Sedan Taxi Pune to Mumbai"],
    ["Online Sedan Booking Pune to Mumbai", "Affordable Sedan Cab Pune to Mumbai"],
    ["Chauffeur Driven Sedan Pune to Mumbai", "Private Sedan Travel Pune to Mumbai"],
    ["Comfortable Sedan Pune to Mumbai Ride", "Budget Sedan Hire Pune Mumbai Route"],
    ["Sedan Car Rental Pune to Mumbai", "Long Drive Sedan Pune to Mumbai"],
    ["Corporate Sedan Travel Pune to Mumbai", "Fast Sedan Cab Pune to Mumbai"],
    ["Family Sedan Cab Pune to Mumbai", ""]
  ],




"whychoose": [
    {
        "WhyChooseheading": "Comfortable and Reliable Pune to Mumbai Sedan Cab Service",
        "WhyChoosedescription": "Our sedan cab service offers a perfect balance of comfort, style, and efficiency for your Pune to Mumbai journey. Whether traveling solo or with a small group, enjoy a smooth and relaxed ride in well-maintained sedans, designed to make your intercity travel hassle-free."
    },
    {
        "WhyChooseheading": "Well-Maintained, Clean, and Air-Conditioned Sedans",
        "WhyChoosedescription": "We provide modern sedans with clean interiors, effective air-conditioning, and comfortable seating. Each vehicle undergoes regular maintenance and sanitization to ensure you travel in a safe and pleasant environment, ideal for both business and leisure trips."
    },
    {
        "WhyChooseheading": "Professional and Experienced Drivers",
        "WhyChoosedescription": "Our drivers are trained professionals with deep knowledge of the Pune to Mumbai route. They ensure timely pickups, safe driving, and courteous service, making your journey smooth, secure, and enjoyable from start to finish."
    },
    {
        "WhyChooseheading": "Transparent and Affordable Pricing",
        "WhyChoosedescription": "Our sedan cab service offers competitive rates with all-inclusive pricing. This covers fuel, tolls, taxes, and driver allowances, so you won’t face any hidden charges. We provide upfront fare details to help you plan your travel budget confidently."
    },
    {
        "WhyChooseheading": "Flexible Booking and Customized Travel Plans",
        "WhyChoosedescription": "Choose from one-way trips, round trips, or hourly rentals tailored to your schedule. Customize your pickup and drop locations anywhere within Pune and Mumbai to fit your specific travel needs and convenience."
    },
    {
        "WhyChooseheading": "Door-to-Door Service for Maximum Convenience",
        "WhyChoosedescription": "We offer direct pickup from your preferred location in Pune and drop you off at your exact destination in Mumbai. This seamless door-to-door service eliminates the need for multiple transfers or waiting at cab stands."
    },
    {
        "WhyChooseheading": "Ideal for Airport Transfers, Business Travel, and Personal Trips",
        "WhyChoosedescription": "Whether you’re catching a flight at Mumbai Airport, attending a business meeting, or visiting family and friends, our sedan cabs provide the perfect blend of comfort, privacy, and reliability for all types of travel."
    },
    {
        "WhyChooseheading": "24/7 Customer Support and Easy Online Booking",
        "WhyChoosedescription": "Our customer support team is available around the clock to assist with your booking, modifications, or special requests. With our user-friendly online platform, you can book your sedan cab anytime, ensuring a hassle-free and efficient travel experience."
    }
]




















    }

const faqData = [
    {
        question: "How can I book a sedan cab from Pune to Mumbai?",
        answer: "You can book a sedan cab easily by calling Meghana Cab at +91 9075462128 or through our website for instant booking."
    },
    {
        question: "What types of sedan cars are available for Pune to Mumbai trips?",
        answer: "We offer well-maintained sedans like Dzire, Etios, and Amaze, ideal for 3–4 passengers with luggage."
    },
    {
        question: "How long does the Pune to Mumbai journey take in a sedan cab?",
        answer: "The trip typically takes around 3 to 4 hours, depending on the time of day and traffic."
    },
    {
        question: "Is the Pune to Mumbai sedan cab service available 24/7?",
        answer: "Yes, our sedan cab service runs 24/7, including late nights and early mornings."
    },
    {
        question: "Is one-way travel allowed for sedan cabs between Pune and Mumbai?",
        answer: "Yes, you can book both one-way and round-trip rides as per your requirement."
    },
    {
        question: "What does the fare for a sedan cab include?",
        answer: "The fare includes fuel, tolls, and driver charges. Extra parking fees or waiting time may be billed separately."
    },
    {
        question: "Is the sedan suitable for airport transfers from Pune to Mumbai?",
        answer: "Yes, sedan cabs are ideal for comfortable and affordable airport transfers with enough luggage space."
    },
    {
        question: "Can I request rest stops during the ride?",
        answer: "Yes, meal or rest stops can be arranged—just inform the driver or let us know during booking."
    },
    {
        question: "Are your sedan drivers experienced and verified?",
        answer: "Yes, all our drivers are experienced, background-verified, and familiar with the Pune–Mumbai route."
    },
    {
        question: "Can I book the sedan cab online?",
        answer: "Absolutely! You can book a sedan online through our website 24/7 with secure payment options."
    },
];

const testimonialsData = [
    {
        name: 'Mr. Rohan Pawar',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Booked a Dzire from Pune to Mumbai. Very clean car, smooth ride, and a professional driver. Great service!”',
    },
    {
        name: 'Ms. Vaishali Desai',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Comfortable and affordable sedan cab service from Pune to Mumbai. Booking was seamless and the journey was stress-free.”',
    },
];




























































































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9075462128",
            "+91 8452916550",

        ],
        email: "booking@meghanacabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Online Cab Booking in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Kolhapur Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Satara Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Hyderabad Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Bangalore Cab",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Pune to Indore Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Gujarat Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Lonavala Taxi",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Jejuri Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Local Taxi Service in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Lavasa Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Pune to Kashid Beach Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "One Way Cab Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Round Trip Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Taxi Service Near Me",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Car Hire in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Seater Car on Rent in Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Cab Service in Pimpri Chinchwad",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune Taxi Cab Services",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Pune Airport Taxi",
        },

        {
            place: "/images/keyword/21.jpg",
            text: "Pune to Rajasthan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Matheran Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Pandharpur Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Mumbai Cabs",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Mumbai Airport Cab ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to Mumbai Taxi",
        },
    ];


    const images = [
        { src: "/images/booking/1.jpg", alt: "Image 1" },
        { src: "/images/booking/5.jpg", alt: "Image 1" },
        { src: "/images/booking/2.jpg", alt: "Image 1" },
        { src: "/images/booking/3.jpg", alt: "Image 1" },
        { src: "/images/booking/4.jpg", alt: "Image 1" },
        { src: "/images/booking/7.jpg", alt: "Image 1" },
        { src: "/images/booking/8.jpg", alt: "Image 1" },
        { src: "/images/booking/9.jpg", alt: "Image 1" },
        { src: "/images/booking/6.jpg", alt: "Image 1" },

    ];






const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Mumbai Sedan Cab Service",
  "image": "https://www.meghanacabs.com/assets/images/pune-to-mumbai-sedan-cab.jpg",
  "description": "Book comfortable and affordable sedan cab service from Pune to Mumbai with Meghana Cabs. Choose AC sedans for one-way or round trips, with chauffeur-driven options available. Easy online booking 24/7.",
  "brand": {
    "@type": "Brand",
    "name": "Meghana Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "5213"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1700",
    "availability": "https://schema.org/InStock",
    "url": "https://www.meghanacabs.com/pune-to-mumbai-sedan-cab-service"
  }
};










    return (
        <div>
<Helmet>
  <title>Pune to Mumbai Sedan Cab Service | Meghana Cabs</title>
  <meta 
    name="description" 
    content="Affordable and comfortable sedan cab service from Pune to Mumbai by Meghana Cabs. AC sedans for one-way and round trip travel with chauffeur-driven options. Book online 24/7." 
  />
  <meta 
    name="keywords" 
    content="Sedan Cab Hire Pune to Mumbai, AC Sedan Taxi Pune to Mumbai, One Way Sedan Cab Pune to Mumbai, Round Trip Sedan Taxi Pune to Mumbai, Online Sedan Booking Pune to Mumbai, Affordable Sedan Cab Pune to Mumbai, Chauffeur Driven Sedan Pune to Mumbai, Private Sedan Travel Pune to Mumbai, Comfortable Sedan Pune to Mumbai Ride, Budget Sedan Hire Pune Mumbai Route, Sedan Car Rental Pune to Mumbai, Long Drive Sedan Pune to Mumbai, Corporate Sedan Travel Pune to Mumbai, Fast Sedan Cab Pune to Mumbai, Family Sedan Cab Pune to Mumbai" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <section className="page-title centred">
                <div className="bg-layer" style={{ backgroundImage: 'url(/images/page-header-bg.jpg)' }}></div>
                <div className="auto-container">
                    <div className="content-box">

                        <h1>{cardData.keyword}</h1>
                    </div>
                </div>
            </section>




            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/Keywords/63.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F2614C', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3 text-dark'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Meghana Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <Accordion data={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3 className=' text-dark'>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F1604F',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F1604F' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919075462128" className="d-block  text-white">+91 9075462128</a>
                                                <a href="tel:+918452916550" className="d-block  text-white">+91 8452916550</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@meghanacabs.com" className=" text-white d-block">
                                                    booking@meghanacabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Meghana Cab  <br />
                                                        Yelwande Wasti. Opp Vithal Lawans, Laxmi Chowk, Hinjawadi, Pune - 411057
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Punetomumbaisedancabservice;